<div class="header-navigation-back">
  <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
  <span fxFlex class="title">Criminal background check</span>
</div>
<div fxLayout="column" fxLayoutAlign="center stretch">
  <div fxFlex fxLayout="column" class="padding-left-md" [innerHTML]="html"></div>
</div>
